'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();

import Script from 'next/script';
import { useCookies } from 'shared/contexts/CookiesContext';

const dev = process.env.NODE_ENV === 'development';
const GA_TRACKING_ID = process.env.NEXT_PUBLIC_GA_ID;

export default function GoogleTagManagerTrackingCode() {
  const { enabledCookies } = useCookies();
  if (!enabledCookies.tracking || dev) return null;

  return (
    <Script
      id="gtag-tracking"
      dangerouslySetInnerHTML={{
        __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());

            gtag('config', '${GA_TRACKING_ID}');
            gtag('config', 'UA-28410282-1');
            gtag('config', 'G-81644KKL5E');
            gtag('config', 'G-JJRXDY14B5');
          `,
      }}
    />
  );
}
